import { hideOthers as ah } from "aria-hidden";
const hideOthers = ah;
export { hideOthers };
//# sourceMappingURL=AriaHidden.mjs.map
